import React, { useState, useEffect, useRef } from "react";
import Popup from "../../components/common/popup/Popup";

export default function Premium_sports() {
    document.title = "Premium Sports";
    const initialized = useRef(false);
    const [premiumSports, setPremiumSports] = useState();
    const token = sessionStorage.getItem("token");
    const [isError, setIsError] = useState(false);
        const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
        if (!initialized.current) {
          initialized.current = true;
          callAPI();
        }
      }, [premiumSports]);

    const callAPI = () => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", `Bearer ${token}`);
    
        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow",
        };
    
        fetch(`${process.env.REACT_APP_BASE_URL}/premium_sports`, requestOptions)
          .then(async (response) => {
            console.log("response code : ",response.status)
            let paresData = await response.json();
            if(response.ok){
              setPremiumSports(paresData);
              console.log("premium_sports - ", paresData);
            }else if(response.status === 401){
          setIsError(true);
          setErrorMsg(paresData.message);
          setErrorDisable(); 
        }else if(response.status === 500){
          setIsError(true);
          setErrorMsg(paresData.message);
          setErrorDisable();
      }else{
        setIsError(true);
          setErrorMsg(paresData.message);
          setErrorDisable();
      }
          })
          .catch((error) => {
            console.log(error.message);
          });
      };
      const setErrorDisable = () => {
    setTimeout(() => {
      setIsError(false);
      window.location.href = "/";
    }, 1000);
  };
  return (
    <>
    <Popup
            popupClass={`alertMsgpopup ${isError ? "open" : ""}`}
            content={
              <div className={`alert-msg err`}>
                <span className="msg">{errorMsg}</span>
                <div className="alert-progress-bar"></div>
              </div>
            }
          />
    <div style={{ width: "100%", height: "100vh" }}>
      {premiumSports && <iframe
        src={premiumSports.urldata.url} // Replace with the desired URL
        title={'premiumSports'}
        style={{ width: "100%", height: "100%", border: "none" }}
      />}
    </div>
  </>
  )
}
